// import the react components
import React, {useState, useEffect} from "react";
import {FiSettings} from "react-icons/fi";

// import the colors
import {gradient_primary} from "./../assets/data/colors";

// import the context
import {useStateContext} from "./../context/";

// the setting button functional based component
const SettingButton = () => {
    const {set_side_setting} = useStateContext();
    const [isNearFooter, setIsNearFooter] = useState(false);
    useEffect(() => {
    const handleScroll = () => {
        const scrollY = window.scrollY;
        const windowHeight = window.innerHeight;
        const fullHeight = document.body.offsetHeight;

        if (scrollY + windowHeight > fullHeight - 120) {
            setIsNearFooter(true);
        } else {
            setIsNearFooter(false);
        }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    // return to the component data
    return (
        <div className="fixed right-4 bottom-14 z-50">
            <button type="button" className={`fixed right-4 z-50 transition-all duration-300 ${isNearFooter ? "bottom-28" : "bottom-10"} text-3xl p-3 hover:drop-shadow-x1 hover:bg-light-gray text-white hover:opacity-80`} style={{background: gradient_primary, borderRadius: "50%"}} onClick={() => set_side_setting(true)}>
                <FiSettings />
            </button>
        </div>
    );
};
export default SettingButton;